const profile = {
    name: "Ім'я",
    avatar: 'Аватар',
    givenName: "Ім'я",
    familyName: 'Прізвище',
    middleName: 'По батькові',
    fullname: "Повне ім'я",
    nickname: 'Псевдонім',
    preferredUsername: "Бажане ім'я користувача",
    profile: 'Профіль',
    website: 'Вебсайт',
    gender: 'Стать',
    birthdate: 'Дата народження',
    zoneinfo: 'Часовий пояс',
    locale: 'Локаль',
    address: {
        formatted: 'Адреса',
        streetAddress: 'Вулиця',
        locality: 'Місто',
        region: 'Штат/Область',
        postalCode: 'Поштовий індекс',
        country: 'Країна',
    },
    gender_options: {
        female: 'Жіноча',
        male: 'Чоловіча',
        prefer_not_to_say: 'Волію не говорити',
    },
    checkbox_value: {
        checked: 'Так',
        unchecked: 'Ні',
    },
    avatar_upload: {
        upload: 'Завантажити',
        remove: 'Видалити',
        uploading: 'Завантаження...',
        hint: 'Рекомендований розмір 1:1, до {{limit}}.',
        error_file_type: 'Тип файлу має бути {{extensions}}.',
        error_file_size: 'Розмір файлу не повинен перевищувати {{limit}}.',
        error_storage_not_configured: 'Не вдалося завантажити фото. Спробуйте пізніше.',
        error_upload: 'Не вдалося завантажити фото. Спробуйте ще раз.',
        error_save: 'Не вдалося зберегти ваше фото. Спробуйте ще раз.',
        crop_title: 'Обрізати фото',
        zoom: 'Масштаб',
        error_crop: 'Не вдалося обрізати зображення. Спробуйте ще раз.',
    },
};
export default Object.freeze(profile);
